import Vue from "vue";

Vue.mixin({
    methods: {
        getQuestionLabelFromSlug(slug) {
            let questionnaire = window.Laravel.questionnaires.find(q => q.questions.map(qq => qq.name)?.includes(slug))
            if (!questionnaire)
                return slug;

            return questionnaire.questions.find(q => q.name === slug)?.label;
        }
    },
});
